import type React from 'react';

import { Box, Card, Heading, Icon, Text } from '@zillow/constellation-10';
import { IconAwardRibbonFilled, IconMegaphoneFilled } from '@zillow/constellation-icons';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <IconMegaphoneFilled />,
  children = null,
  header = null,
  isPremiumTip = false,
}: Props) => (
  <Card.Root
    tone="neutral"
    elevated={false}
    css={{
      padding: '{spacing.600} {spacing.400}',
      borderRadius: '12px',
      width: isPremiumTip ? { base: '100%', xl: '294px' } : { base: '100%', md: '294px' },
      borderTop: isPremiumTip ? '3px solid {colors.border.accent.brand.hero}' : undefined,
    }}
  >
    <Card.Body css={{ padding: 'none' }}>
      <Box css={{ marginBottom: '400' }}>
        {isPremiumTip ? (
          <>
            <Icon
              render={<IconAwardRibbonFilled />}
              size="sm"
              css={{ color: 'icon.accent.brand.hero', verticalAlign: 'middle' }}
            />
            <Text textStyle="body-sm-bold" css={{ color: 'text.accent.brand.hero' }} asChild>
              <span> Premium</span>
            </Text>
          </>
        ) : (
          <Icon render={icon} size="xl" css={{ color: 'icon.subtle' }} />
        )}
      </Box>

      {header && (
        <Box css={{ marginBottom: '400' }}>
          <Heading level={6} id="tip-title">
            {header}
          </Heading>
        </Box>
      )}

      {children}
    </Card.Body>
  </Card.Root>
);

export default WizardTipCard;
